// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFileVersion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15 22H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h6.672a2 2 0 0 1 1.414.586l4.328 4.328A2 2 0 0 1 20 8.328v5.088A4.983 4.983 0 0 0 18 13v-3h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6.416a5.017 5.017 0 0 0 1.583 2zm2.672-14L14 4.328V8zm4.332 10.006a4.002 4.002 0 1 1-8.004 0 4.002 4.002 0 0 1 8.004 0zm-4.584.332 1.742 1.742c.107.107.28.107.387 0l.259-.258a.274.274 0 0 0 0-.387l-1.475-1.475v-2.086a.274.274 0 0 0-.274-.274h-.365a.274.274 0 0 0-.274.274z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFileVersion;
